export const DELETE_CLASS_MODAL_STAGES = {
  notOpen: 'notOpen',
  reason: 'reason',
  confirm: 'confirm',
  validation: 'validation',
};
